/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_FaqInputs */

const he_nav_faq = /** @type {(inputs: Nav_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שאלות נפוצות`)
};

const en_nav_faq = /** @type {(inputs: Nav_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Nav_FaqInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_faq = /** @type {((inputs?: Nav_FaqInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_FaqInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_faq(inputs)
	return en_nav_faq(inputs)
});